import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import TextField from "@material-ui/core/TextField";

import appRoutes from "../../routes/appRoutes";

import MakeAPICall from "../../apiCalls/common";

import {
  exportDataApiRoute,
  getDoctorListApiRoute,
  blockDoctorApiRoute,
  deleteDoctorApiRoute,
  sendPatNotificationApiRoute,
  getListOfPatientsWhoBlockedApiRoute,
  deleteDoctorStripeAccountApiRoute
} from "../../apiRoutes";

import { getFormattedDate, getFormattedTime } from "../../utils/dateTimeHelper";
import { sortData, csUndefined } from "../../utils/commonMethods";

import Button from "../../components/button";
import Loader from "../../components/loader";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTable from "../../components/datatable/customDataTable";
import CustomModal from "../../components/modal";

import SendNotificationForm from "../../containers/PatientsForms/sendNotificationForm";
import ViewProfilePic from "../../components/viewProfilePic";
import DoctorBlockedBy from "../../containers/DoctorForms/doctorsBlockedBy";

import ICNoImg from "../../assets/images/default-picture.png";

const DoctorsApprovedPage = props => {
  const csvDownRef = useRef(null);
  let history = useHistory();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [filterBlock, setFilterBlock] = useState("none");
  const [currFilters, setCurrFilters] = useState(
    props.location && props.location.state && props.location.state.currPageNo
      ? {
          skip: props.location.state.currPageNo.skip,
          limit: props.location.state.currPageNo.limit
        }
      : {
          skip: 0,
          limit: 10
        }
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [doctorsList, setDoctorsList] = useState([]);
  const [currSelDoct, setCurrSelDoct] = useState(null);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [showUnblockModal, setShowUnblockModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showBlockByModal, setShowBlockByModal] = useState(false);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [showSendNotificationModal, setShowSendNotificationModal] = useState(
    false
  );
  const [showViewProfilePicModal, setShowViewProfilePicModal] = useState(false);
  const [patientsList, setPatientsList] = useState([]);
  const [showSuccModal, setShowSuccModal] = useState(false);
  const [succModalText, setSuccModalText] = useState("");
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");

  const [showDelStripeModal, setShowDelStripeModal] = useState(false);


  const tableHeaders = [
    {
      key: "docId",
      value: "UIN"
    },
    {
      key: "profilePic",
      value: "Profile Pic"
    },
    {
      key: "fullName",
      value: "Doctor Details"
    },
    { key: "dateOfBirth", value: "DOB" },
    { key: "gender", value: "Gender" },
    {
      key: "action",
      value: "Action"
    }
  ];

  let excelSheetHeader = [
    { label: "UIN", key: "UIN" },
    { label: "Profile Pic", key: "Profile_Pic" },
    { label: "First Name", key: "First_Name" },
    { label: "Middle Name", key: "Middle_Name" },
    { label: "Last Name", key: "Last_Name" },
    { label: "Gender", key: "Gender" },
    { label: "Email Address", key: "Email_Address" },
    { label: "Mobile Number", key: "Mobile_Number" },
    { label: "Unit Number", key: "Unit_Number" },
    { label: "Street Number", key: "Street_Number" },
    { label: "Street Name", key: "Street_Name" },
    { label: "Suburb", key: "Suburb" },
    { label: "State", key: "State" },
    { label: "Postcode", key: "Postcode" },
    { label: "Emergency Contact Name1", key: "Emergency_Contact_Name1" },
    { label: "Emergency Contact Number1", key: "Emergency_Contact_Number1" },
    {
      label: "Emergency Contact Name2",
      key: "Emergency_Contact_Name2"
    },
    {
      label: "Default Bank AccountName",
      key: "Default_Bank_AccountName"
    },
    {
      label: "Default Bank Account Number",
      key: "Default_Bank_Account_Number"
    },
    {
      label: "Default Bank Account BSB",
      key: "Default_Bank_Account_BSB"
    },
    {
      label: "Default Bank Name",
      key: "Default_Bank_Name"
    },
    {
      label: "ABN",
      key: "ABN"
    },
    {
      label: "AHPRA Registration",
      key: "AHPRA_Registration"
    },
    {
      label: "Medicare Provider Number",
      key: "Medicare_Provider_Number"
    },
    {
      label: "Prescriber Number",
      key: "Prescriber_Number"
    },
    {
      label: "eRx ID",
      key: "eRxId"
    },
    {
      label: "Professional Indemnity Insurance Policy",
      key: "Professional_Indemnity_Insurance_Policy"
    },
    {
      label: "HPI-I",
      key: "HPIINumber"
    },
    {
      label: "Application Date",
      key: "Application_Date"
    },
    {
      label: "Application Time",
      key: "Application_Time"
    },
    {
      label: "Approval Date",
      key: "Approval_Date"
    },
    {
      label: "Approval Time",
      key: "Approval_Time"
    },
    {
      label: "Additional Notes from Application",
      key: "Additional_Notes_from_Application"
    },
    {
      label: "Additional Notes Regarding This Doctor",
      key: "Additional_Notes_Regarding_This_Doctor"
    },
    {
      label: "Average Star Rating",
      key: "Average_Star_Rating"
    },
    {
      label: "Status",
      key: "Status"
    }
  ];

  const handleBlockedFilterChange = e => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.skip = 0;
    setCurrFilters(newFilter);
    if (e.target.value === "none") {
      setFilterBlock("none");
    } else {
      setFilterBlock(e.target.value);
    }
  };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.text = filters.text;
    setCurrFilters(newFilter);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, doctorsList);
    setDoctorsList(sortedData);
  };

  const showDoctorProfile = id => {
    history.push(appRoutes.doctorApproved + "/" + id, {
      currPageNo: currFilters
    });
  };

  // get doctors list
  const getDoctorsList = () => {
    setIsProcessing(true);

    let filters = Object.assign({}, currFilters);
    if (filterBlock !== "none") {
      filters.isBlocked = filterBlock;
    }

    setApiCallParams({
      reqType: "GET",
      reqUrl: getDoctorListApiRoute,
      params: filters,
      successCallback: async res => {
        let list = [];

        await res.data.data.doctorData.forEach(column => {
          let d = {};

          d._id = column._id;
          d.docId = column.doctorId;
          d.gender = column.gender;
          d.phoneNumber = column.phoneNumber;
          d.accountState = column.accountState;
          d.visibilityMode = column.visibilityMode;
          d.isBlocked = column.isBlocked;
          d.profilePic =
            column.profilePic === null || column.profilePic === undefined
              ? ICNoImg
              : column.profilePic.original;
          d.dateOfBirth = column.dateOfBirth;
          d.email = column.email;
          d.fullName = column.firstName + " ";
          if (
            column.middleName !== null &&
            column.middleName !== undefined &&
            column.middleName !== ""
          ) {
            d.fullName = d.fullName + column.middleName + " ";
          }

          d.fullName = d.fullName + column.lastName;

          if (
            column.manageAccount &&
            column.manageAccount._id &&
            column.stripeDelete
          ) {
            d.stripeDelete = true;
          }
          if (
            column.manageAccount &&
            (column.stripeDelete === undefined || column.stripeDelete === false)
          ) {
            d.stripeDelete = false;
          }

          list.push(d);
        });

        setDoctorsList(list);
        setTotalRecords(res.data.data.totalCount);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // export data
  const exportPatData = e => {
    e.preventDefault();

    setIsProcessing(true);
    var formData = new FormData();
    formData.append("who", "doctor");
    formData.append("rejected", false);

    setApiCallParams({
      reqType: "POST",
      reqUrl: exportDataApiRoute,
      dataObj: formData,
      successCallback: async res => {
        var excelArray = [];
        await res.data.data.forEach(function (column) {
          var e = {};
          e.UIN = column.doctorId;
          e.Profile_Pic = column.profilePic ? column.profilePic.thumb : "";
          e.First_Name = column.firstName;
          e.Middle_Name = column.middleName;
          e.Last_Name = column.lastName;
          e.Gender = column.gender;
          e.Email_Address = column.email;
          e.Mobile_Number = column.phoneNumber;
          e.Unit_Number =
            column.address.unitNumber !== null ? column.address.unitNumber : "";
          e.Street_Number = column.address.streetNumber;
          e.Street_Name = column.address.streetName;
          e.Suburb = column.address.suburb;
          e.State = column.address.state;
          e.Postcode = column.address.postCode;
          if (column.ec1) {
            e.Emergency_Contact_Name1 =
              column.ec1.name === "" ||
              column.ec1.name === null ||
              column.ec1.name === undefined
                ? " "
                : column.ec1.name;
            e.Emergency_Contact_Number1 =
              column.ec1.contact === "" ||
              column.ec1.contact === null ||
              column.ec1.contact === undefined
                ? " "
                : column.ec1.contact;
          } else {
            e.Emergency_Contact_Name1 = " ";
            e.Emergency_Contact_Number1 = " ";
          }
          if (column.ec2) {
            e.Emergency_Contact_Name2 =
              column.ec2.name === "" ||
              column.ec2.name === null ||
              column.ec2.name === undefined
                ? " "
                : column.ec2.name;
            e.Emergency_Contact_Number2 =
              column.ec2.contact === "" ||
              column.ec2.contact === null ||
              column.ec2.contact === undefined
                ? " "
                : column.ec2.contact;
          } else {
            e.Emergency_Contact_Name2 = " ";
            e.Emergency_Contact_Number2 = " ";
          }

          if (!column.manageAccount) {
            e.Default_Bank_AccountName = " ";
            e.Default_Bank_Account_Number = " ";
            e.Default_Bank_Account_BSB = " ";
            e.Default_Bank_Name = " ";
          } else if (column.manageAccount) {
            e.Default_Bank_AccountName = column.manageAccount.accountHolderName;
            e.Default_Bank_Account_Number =
              column.manageAccount.bankAccoutLastFourDigit;
            e.Default_Bank_Account_BSB = column.manageAccount.routingNumber;
            e.Default_Bank_Name = column.manageAccount.bankAccountName;
          }
          e.ABN =
            column.ABN === "" || column.ABN === undefined || column.ABN === null
              ? " "
              : column.ABN;
          if (column.AHPRA) {
            e.AHPRA_Registration = column.AHPRA;
          } else {
            e.AHPRA_Registration = " ";
          }
          if (column.medicalProviderNo) {
            e.Medicare_Provider_Number = column.medicalProviderNo;
          } else {
            e.Medicare_Provider_Number = " ";
          }
          if (column.prescriberNo) {
            e.Prescriber_Number = column.prescriberNo;
          } else {
            e.Prescriber_Number = " ";
          }
          if (column.eRxId) {
            e.eRxId = column.eRxId;
          } else {
            e.eRxId = " ";
          }
          if (column.PIIP) {
            e.Professional_Indemnity_Insurance_Policy = column.PIIP;
          } else {
            e.Professional_Indemnity_Insurance_Policy = " ";
          }

          if (column.HPIIInfo && column.HPIIInfo.HPIINumber) {
            e.HPIINumber = column.HPIIInfo.HPIINumber;
          } else {
            e.HPIINumber = "";
          }

          e.Application_Date = getFormattedDate(column.createdAt);
          e.Application_Time = getFormattedTime(column.createdAt);
          e.Approval_Date = getFormattedDate(column.approvedAt);
          e.Approval_Time = getFormattedTime(column.approvedAt);

          if (column.additionalNotesApplication) {
            e.Additional_Notes_from_Application = csUndefined(
              column.additionalNotesApplication
            );
          } else {
            e.Additional_Notes_from_Application = " ";
          }
          if (column.additionalNotesDoctor) {
            e.Additional_Notes_Regarding_This_Doctor = csUndefined(
              column.additionalNotesDoctor
            );
          } else {
            e.Additional_Notes_Regarding_This_Doctor = " ";
          }
          e.Average_Star_Rating = (
            column.totalRating / column.ratedCount
          ).toFixed(1);
          e.Status = column.isBlocked === false ? "Unblocked" : "Blocked";

          excelArray.push(e);
        });

        setExcelSheetData(excelArray);
        setIsProcessing(false);

        // after setting the excel sheet data trigger the csv download component click event
        csvDownRef.current.link.click();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // unblock doctor
  const unblockSelDoctor = () => {
    setShowUnblockModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("doctor_id", currSelDoct._id);
    formData.append("isBlocked", false);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: blockDoctorApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText(
          "Dr. " + currSelDoct.fullName + " Unblocked Successfully"
        );
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };

  // block doctor
  const blockSelDoctor = () => {
    setShowBlockModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("doctor_id", currSelDoct._id);
    formData.append("isBlocked", true);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: blockDoctorApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText(
          "Dr. " + currSelDoct.fullName + " Blocked Successfully"
        );
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };

  // move doctor
  const moveSelDoctor = () => {
    setShowMoveModal(false);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: deleteDoctorApiRoute + currSelDoct._id,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Dr. " + currSelDoct.fullName + " Moved Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // send notification
  const sendDocNotification = msg => {
    setShowSendNotificationModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("doctorId", currSelDoct._id);
    formData.append("message", msg);
    formData.append("user", "Doctor");
    formData.append("fromWhere", "doctor");
    formData.append("isSMS", true);
    formData.append("isEmail", true);
    formData.append("isPushNotification", true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: sendPatNotificationApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Notification Sent To Doctor Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // get patients list who blocked the selected doctor
  const getPatientListWhoBlockDoctor = async doct => {
    setIsProcessing(true);

    let parms = {
      doctorId: doct._id,
      skip: 0,
      limit: 0
    };

    await setApiCallParams({
      reqType: "GET",
      reqUrl: getListOfPatientsWhoBlockedApiRoute,
      params: parms,
      successCallback: res => {
        setIsProcessing(false);
        setPatientsList(res.data.data);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    getDoctorsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters, filterBlock]);

  // restore the previous page state
  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.currPageNo &&
      props.location.state.currPageNo !== null
    ) {
      setCurrFilters({
        skip: props.location.state.currPageNo.skip,
        limit: props.location.state.currPageNo.limit
      });
    }
  }, []);

  const showDocPicModal = doct => {
    setCurrSelDoct(doct);
    setShowViewProfilePicModal(true);
  };

  const showBlockDocMoal = doct => {
    setCurrSelDoct(doct);
    setShowBlockModal(true);
  };

  const showSendNotificationDocModal = doct => {
    setCurrSelDoct(doct);
    setShowSendNotificationModal(true);
  };

  const showUnblockDocMoal = doct => {
    setCurrSelDoct(doct);
    setShowUnblockModal(true);
  };

  const showBlockedByPatModal = doct => {
    setCurrSelDoct(doct);
    getPatientListWhoBlockDoctor(doct);
    setShowBlockByModal(true);
  };

  const showMoveDocModal = doct => {
    setCurrSelDoct(doct);
    setShowMoveModal(true);
  };

  const showDocDelStripeModal = doct => {
    setCurrSelDoct(doct);
    setShowDelStripeModal(true);
  };

    // delete selected doctor stripe account
    const delSelDoctorStripeAccount = () => {
      setShowDelStripeModal(false);
      setIsProcessing(true);
  
      var formData = new FormData();
      formData.append("doctorId", currSelDoct.docId);
  
      setApiCallParams({
        reqType: "POST",
        reqUrl: deleteDoctorStripeAccountApiRoute,
        dataObj: formData,
        successCallback: res => {
          setIsProcessing(false);
          setSuccModalText("Stripe Account Deleted Successfully");
          setShowSuccModal(true);
        },
        failureCallback: err => {
          setIsProcessing(false);
          // setErrModalText(
          //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          // );
          // setShowErrModal(true);
        }
      });
    };

  return (
    <div className="view-ticket-container logins-page-container">
      <CustomModal
        className="modal-lg"
        openModal={showBlockByModal}
        cancelEvent={() => {
          setShowBlockByModal(false);
          setCurrSelDoct(null);
          setPatientsList([]);
        }}
        title="Blocked By"
        modalBodyContent={<DoctorBlockedBy data={patientsList} />}
        useOneButton={true}
        cancelText="Close"
      />
      <CustomModal
        openModal={showViewProfilePicModal}
        cancelEvent={() => {
          setShowViewProfilePicModal(false);
          setCurrSelDoct(null);
        }}
        title="View Profile Pic"
        modalBodyContent={
          <ViewProfilePic
            profileImg={currSelDoct !== null ? currSelDoct.profilePic : ICNoImg}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        openModal={showSendNotificationModal}
        cancelEvent={() => {
          setShowSendNotificationModal(false);
          setCurrSelDoct(null);
        }}
        title="Send Notification"
        modalBodyContent={
          <SendNotificationForm onFormSubmit={sendDocNotification} isDoctor={true} doctorData={currSelDoct}/>
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showUnblockModal}
        cancelEvent={() => {
          setShowUnblockModal(false);
          setCurrSelDoct(null);
        }}
        okayEvent={unblockSelDoctor}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to unblock this doctor?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showBlockModal}
        cancelEvent={() => {
          setShowBlockModal(false);
          setCurrSelDoct(null);
        }}
        okayEvent={blockSelDoctor}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to block this doctor?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showMoveModal}
        cancelEvent={() => {
          setShowMoveModal(false);
          setCurrSelDoct(null);
        }}
        okayEvent={moveSelDoctor}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to move this doctor?
          </p>
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
          setErrModalText("");
          setCurrSelDoct(null);
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showSuccModal}
        cancelEvent={() => {
          setShowSuccModal(false);
          setSuccModalText("");
          setCurrSelDoct(null);
          getDoctorsList();
        }}
        modalBodyContent={<p className="text-center mb-0">{succModalText}</p>}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDelStripeModal}
        cancelEvent={() => {
          setShowDelStripeModal(false);
          setCurrSelDoct(null);
        }}
        okayEvent={delSelDoctorStripeAccount}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete the Stripe Connected Account for
            <br />
            Dr. {currSelDoct ? currSelDoct.fullName : ""}?
          </p>
        }
      />
      <div className="d-flex flex-row flex-wrap justify-content-between">
        <h3>Approved</h3>
        <div className="d-flex flex-row align-items-end">
          <TextField
            select
            SelectProps={{
              native: true
            }}
            onChange={handleBlockedFilterChange}
            value={filterBlock}
          >
            <option value="none">Select Blocked Status</option>
            <option value="false">Unblocked</option>
            <option value="true">Blocked</option>
          </TextField>
          {filterBlock !== "none" && (
            <button
              style={{ minWidth: "30px", width: "30px" }}
              className="insta-button-primary ic-btn-red ml-3"
              onClick={() => {
                setFilterBlock("none");
              }}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          )}
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button clickEvent={exportPatData} title="Export to CSV"></Button>
          <CSVLink
            style={{ display: "none" }}
            ref={csvDownRef}
            className="no-text-decoration"
            filename={"Approved_Doctor_list.csv"}
            data={excelSheetData}
            headers={excelSheetHeader}
          ></CSVLink>
        </div>
      </div>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
        >
          {console.log(doctorsList)}
          {doctorsList.map((doctor, index) => (
            <tr key={index} onClick={() => showDoctorProfile(doctor._id)}>
              <td>{doctor.docId}</td>
              <td
                onClick={e => {
                  e.stopPropagation();
                  showDocPicModal(doctor);
                }}
                className="text-center"
              >
                <img
                  className="rounded-circle user-img"
                  src={doctor.profilePic}
                  alt="user-img"
                />
              </td>
              <td>
                <div className="d-flex flex-column">
                  <p className="mb-0">
                    <b>{doctor.fullName}</b>
                    {doctor.visibilityMode && doctor.visibilityMode === true && (
                      <span>
                        &nbsp;<i className="doctor-live-circle"></i>
                      </span>
                    )}
                  </p>
                  <a
                    onClick={e => {
                      e.stopPropagation();
                    }}
                    className="high-z-index list-email"
                    href={"mailto:" + doctor.email}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {doctor.email}
                  </a>
                  <p className="mb-0">
                    <ICPhoneDisplay value={doctor.phoneNumber} />
                  </p>
                </div>
              </td>
              <td>{doctor.dateOfBirth}</td>
              <td>{doctor.gender}</td>
              <td>
                <div className="d-flex flex-row align-items-center justify-content-center pt-2">
                  {!doctor.isBlocked && (
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        showBlockDocMoal(doctor);
                      }}
                      type="button"
                      className="btn btn-out-green high-z-index"
                    >
                      <i className="fas fa-lock-open"></i>
                    </button>
                  )}
                  {doctor.isBlocked && (
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        showUnblockDocMoal(doctor);
                      }}
                      type="button"
                      className="btn btn-out-delete high-z-index"
                    >
                      <i className="fas fa-lock"></i>
                    </button>
                  )}

                  <button
                    onClick={e => {
                      e.stopPropagation();
                      showSendNotificationDocModal(doctor);
                    }}
                    type="button"
                    className="btn btn-out-bell high-z-index ml-2"
                  >
                    <i className="fas fa-bell"></i>
                  </button>
                  <button
                    onClick={e => {
                      e.stopPropagation();
                      showMoveDocModal(doctor);
                    }}
                    type="button"
                    className="btn btn-out-delete high-z-index ml-2"
                  >
                    <i className="fas fa-reply"></i>
                  </button>
                  &nbsp;&nbsp;
                  {doctor.stripeDelete === false && (
                    <button
                      style={{
                        width: "fit-content",
                        padding: "0 10px"
                      }}
                      className="ic-btn-stripe"
                      onClick={e => {
                        e.stopPropagation();
                        showDocDelStripeModal(doctor);
                      }}
                    >
                      <i
                        className="fab fa-cc-stripe"
                        style={{
                          color: "blue",
                          verticalAlign: "bottom",
                          fontSize: "30px"
                        }}
                      ></i>
                    </button>
                  )}
                  {/* {doctor.stripeDelete === true && (
                    <button
                      style={{
                        width: "fit-content",
                        padding: "0 10px"
                      }}
                      className="ic-btn-stripe"
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    >
                      <i
                        className="fab fa-cc-stripe"
                        style={{
                          color: "gray",
                          verticalAlign: "bottom",
                          fontSize: "30px"
                        }}
                      ></i>
                    </button>
                  )} */}
                </div>
                {/* <p
                  onClick={e => {
                    e.stopPropagation();
                    showBlockedByPatModal(doctor);
                  }}
                  className="text-center mt-3 blocked-doctor-link"
                >
                  Blocked By?
                </p> */}
              </td>
            </tr>
          ))}
        </CustomDataTable>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

export default DoctorsApprovedPage;
